import { PaymentOptions } from '../enums';
import { UserRoleIndexModel } from './user-roles.model';

export interface ProcessManagerEditModel {
  id: number;
  email: string;
  phoneNumber: string;
  firstName: string;
  lastName: string;
  password: string;
  confirmPassword: string;
  isActive: boolean;
  requesterCompanyId: number;
  supplierCompanyId: number;
  customerId: number;
  nationalIdentityDocument: string;
  position: string;
  extract: string;
  sendNotificationsByEmail: boolean;
  sendNotificationsByPhone: boolean;
}

export interface ProcessManagerModel {
  id: number;
  phoneNumber: string;
  email: string;
  firstName: string;
  lastName: string;
  profileImageFileName: string;
  profileImageFileWebPath: string;
  isActive: boolean;
  isTemporalPassword: boolean;
  sendNotificationsByEmail: boolean;
  sendNotificationsByPhone: boolean;
  requesterCompanyId: number;
  supplierCompanyId: number;
  customerId: number;
  nationalIdentityDocument: string;
  paymentOptions: PaymentOptions;
  position: string;
  extract: string;
  roles: UserRoleIndexModel[];
}

export interface ProcessManagerIndexModel {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  isActive: boolean;
  requesterCompanyId: number;
  supplierCompanyId: number;
  customerId: number;
  nationalIdentityDocument: string;
  appraisalsInProcessCount: number;
  position: string;
  extract: string;
}
